export default "__VITE_ASSET__BmznjMgr__"